import _ from 'underscore';
import { Formatter, ILogMessage } from '@bingads-webui/listener';

export class OneDSPropertyFormatter extends Formatter {
  format(logMessage: ILogMessage): ILogMessage {
    return _.mapObject(logMessage, (val): any => ({
      value: val,
    }));
  }
}
